import React, { useState } from 'react'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { isAfter } from 'date-fns'
import Label from '../../../../../components/Template/Sidebar/Label'
import {
  ExternalLink,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import {
  getActiveLicense,
  getInvoiceLicense,
  isLicenseValid,
} from '../../../../../reducers/userAccount/selectors/license'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import { IntegrationRedirectReason } from '../../../../../screens/IntegrationAirbnb/IntegrationAirbnb'
import { withRouter } from 'react-router'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import Flex from 'typescript-styled-flex'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function Invoices({ isSidebarOpen, history, size = 1 }: IInvoicesProps) {
  const [isOpen, toggleOpen] = React.useState(false)

  const userId = useSelector(getUserId)
  const userPriceGroup = +useSelector(getUserPriceGroup)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)
  const planScope = useLicensePlansScope()
  const activeLicense = useSelector(
    getActiveLicense,
  )
  const skipScope = activeLicense?.has_invoices || userPriceGroup !== 3
  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true &&
      !skipScope
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true &&
      !skipScope
    ) {
      event.preventDefault()
      event.stopPropagation()
      handlePopoverOpen(event)
    }
  }

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //
  //   if (isSidebarOpen) {
  //     setTimeout(() => {
  //       setPopoverAnchor(target)
  //     }, 50)
  //   }
  // }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  const { t } = useTranslation()
  // const lang = useSelector(getSelectedLanguage)
  const invoice = useSelector(getInvoiceLicense)
  const licenseValid = useSelector(isLicenseValid)

  const scopes = useIsScope({
    fvat: [PermissionScope.SCOPE_CAN_USE_INVOICES],
    fvatConfig: [PermissionScope.SCOPE_CAN_USE_INVOICES_SETTINGS],
  })

  // function getHelpLink() {
  //   const pl =
  //     'https://support.bed-booking.com/hc/pl/sections/360003730212-FAKTURY'
  //   const other =
  //     'https://support.bed-booking.com/hc/en-us/sections/360003730212-INVOICES'
  //
  //   return lang === 'pl' || lang === 'pl_PL' ? pl : other
  // }

  const goToInfo = (reason: IntegrationRedirectReason) => {
    history.replace({
      pathname: `/invoice-info`,
      search: history.location.search.includes('mobile') ? '?mobile=1' : '',
      state: { reason },
    })
  }

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Taxes Item Menu Opened', 1)
    Mixpanel.track('Taxes Menu Item Used', {})
  }

  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Tax Rates Item Menu Opened', 1)
    Mixpanel.track('Tax Rates Menu Item Used', {})
  }

  // const handleExternalLinkClick = (e) => {}

  const trackClick3 = (e) => {
    Mixpanel.people.increment(userId, 'Invoices Menu Opened', 1)
    Mixpanel.track('Invoices Menu Item Used', {})
    Mixpanel.track('Invoices Screen View', {})
    if (!isMobile &&
      (isInPlanScope(
        planScope,
        PlansScope.InvoiceOpen,
        userPriceGroup,
      ) && !skipScope)) {
      handlePopoverOpen(e)
    }
    if (((licenseValid && !isInPlanScope(planScope, PlansScope.InvoiceOpen, userPriceGroup)) || skipScope)) {
      if (invoice && invoice.link && isAfter(invoice.license, new Date())) {
        window.open(invoice.link, '_blank')
      } else {
        return goToInfo(IntegrationRedirectReason.NoSyncing)
      }
    }
  }

  // const trackClick4 = () => {
  //   Mixpanel.people.increment(userId, 'Invoices Help Menu Opened', 1)
  //   Mixpanel.track('Invoices Help Menu Item Used', {})
  //   Mixpanel.track('Invoices Help Screen View', {})
  // }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          nested={true}
        >
          <b>
            <FaFileInvoiceDollar size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            {t('BKO_782_InoviceTabName')}
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList
            size={size}
            nested={true}
            style={{ maxHeight: 'var(--full)' }}
          >
            {scopes.fvat && (
              <ExternalLink onClick={isMobile &&
              (isInPlanScope(
                planScope,
                PlansScope.InvoiceOpen,
                userPriceGroup,
              ) && !skipScope) ? () => setIsModalOpened(true) : trackClick3} size={size}>
                <MenuElement
                  size={size}
                  alignCenter
                  // onMouseEnter={
                  //   !isMobile &&
                  //   (isInPlanScope(
                  //     planScope,
                  //     PlansScope.InvoiceOpen,
                  //     userPriceGroup,
                  //   ) && !skipScope)
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                >
                  <Flex alignCenter full>
                    {t('notification_action_open')}
                    {(isInPlanScope(
                      planScope,
                      PlansScope.InvoiceOpen,
                      userPriceGroup,
                    ) && !skipScope) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </ExternalLink>
            )}
            {scopes.fvatConfig && (
              <SmartLink
                onClick={e => {
                  trackClick()
                  handleLinkClick(e, PlansScope.Taxes)
                }}
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.Taxes,
                  '/invoice/taxes',
                  userPriceGroup,
                  skipScope,
                )}
                activeClassName={'active'}
                nested={true}
              >
                <MenuElement
                  size={size}
                  alignCenter
                  // onMouseEnter={
                  //   !isMobile &&
                  //   (isInPlanScope(planScope, PlansScope.Taxes, userPriceGroup) && !skipScope)
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                >
                  <Flex alignCenter full>
                    {t('BKO_773_TaxesMenu')}
                    {(isInPlanScope(
                      planScope,
                      PlansScope.Taxes,
                      userPriceGroup,
                    ) && !skipScope) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}

            {scopes.fvatConfig && (
              <SmartLink
                size={size}
                onClick={e => {
                  trackClick2()
                  handleLinkClick(e, PlansScope.TaxRates)
                }}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.TaxRates,
                  '/invoice/rates',
                  userPriceGroup,
                  skipScope,
                )}
                activeClassName={'active'}
                nested={true}
              >
                <MenuElement
                  size={size}
                  alignCenter
                  // onMouseEnter={
                  //   !isMobile &&
                  //   (isInPlanScope(
                  //     planScope,
                  //     PlansScope.TaxRates,
                  //     userPriceGroup,
                  //   ) && !skipScope)
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                >
                  <Flex alignCenter full>
                    {t('BBO_2880_tax_rates')}
                    {(isInPlanScope(
                      planScope,
                      PlansScope.TaxRates,
                      userPriceGroup,
                    ) && !skipScope) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}

            {/*<ExternalLink*/}
            {/*  onClick={trackClick4}*/}
            {/*  size={size}*/}
            {/*  href={getHelpLink()}*/}
            {/*  target={'_blank'}*/}
            {/*>*/}
            {/*  <MenuElement size={size} alignCenter={true}>*/}
            {/*    {t('title_activity_help')}*/}
            {/*  </MenuElement>*/}
            {/*</ExternalLink>*/}
          </MenuList>
        )}
      </MenuElement>
      <Flex
        style={{ marginLeft: 'auto' }}
        alignCenter
        justifyEnd
      >
        <PopoveredIcon2
          withIcon={false}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          anchorEl={popoverAnchor}
          onOpen={handlePopoverOpen}
          onClose={handlePopoverClose}
        />
      </Flex>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default withRouter(Invoices as any) as any

export interface IInvoicesProps {
  isSidebarOpen?: boolean
  size?: number
  history?: any
}
